import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';
const WhatIsQuietQuitting = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage tagName="p" {...messages.whatIsQuietQuittingBody} />
    </ArticleBody>
  </div>
);

WhatIsQuietQuitting.propTypes = {};

export default WhatIsQuietQuitting;
